import React from 'react'
// components
import ReduxLocationPicker from 'components/FormElements/ReduxForm/ReduxLocationPicker'
import { ReduxDatePicker, ReduxDateTimePicker, ReduxEntitySelect, ReduxInput, ReduxSelect, ReduxTimePicker } from 'components/FormElements'
// constants
import { DATE_FORMAT_VALUES } from 'constants/objects'
// types
import { FieldType, IField, IResponseTypesSet } from 'types/graphql'
// utils
export { getOptions, getFilterValue } from 'components/Modals/RiskViewFilterModal/utils'
import { getFieldValues } from 'utils/form'
import { getValueOptions } from 'utils/systemProcess'
import { getEntitySelectOptions, getEntitySelectQuery, getEntitySelectVariables } from 'utils/fields'

export const getFieldValue = (field: IField, value: any) => {
  if (field.fieldType === FieldType.Switch) {
    return value.value
  }

  if (field.fieldType === FieldType.Tag) {
    return { title: value }
  }

  if (field.fieldType === FieldType.Date) {
    return new Date(value).toISOString()
  }

  if (field.fieldType === FieldType.PickList) {
    return value.value
  }

  if (field.fieldType === FieldType.Lookup) {
    return value?.value
  }

  return getFieldValues([field], { [field.name]: value })[0].value
}

export const generateFieldFilter = (item, fields) => ({
  id: item.id,
  action: item.action,
  fieldType: item.fieldType,
  originalValue: item.value,
  ...(item.systemName && { systemName: item.systemName }),
  value: getFieldValue(
    fields.find((field) => field.id === item.id),
    item.value
  )
})

export const generateFieldValueFromFilter = (filter, fields) => {
  const field = fields?.find((f) => f.id === filter.id)
  return {
    id: filter.id,
    action: filter.action,
    fieldType: filter.fieldType,
    value: filter.originalValue,
    name: field?.label,
    entityName: field?.entityName,
    ...(filter.systemName && { systemName: filter.systemName })
  }
}

export const getValueField = ({
  name,
  field,
  responseTypeSets
}: {
  name: string
  field: IField
  responseTypeSets?: IResponseTypesSet[]
}) => {
  if (!field) {
    return <ReduxInput name={name} disabled />
  }

  if (field.fieldType === FieldType.Date) {
    const format = field.settings?.format

    return (
      <>
        {(!format || format === DATE_FORMAT_VALUES.DATE) && <ReduxDatePicker name={name} />}
        {format === DATE_FORMAT_VALUES.TIME && <ReduxTimePicker name={name} />}
        {format === DATE_FORMAT_VALUES.DATE_TIME && <ReduxDateTimePicker name={name} />}
      </>
    )
  }

  if (field.fieldType === FieldType.Number) {
    return <ReduxInput name={name} type='number' />
  }

  if (field.fieldType === FieldType.Lookup) {
    const query = getEntitySelectQuery(field.source as string[])
    const handleSearch = ({ search, refetch }) =>
      refetch(getEntitySelectVariables({ sources: field.source as string[], search }))

    return (
      <ReduxEntitySelect
        isGrouped
        name={name}
        query={query}
        field={field}
        handleSearch={handleSearch}
        getOptions={getEntitySelectOptions(field)}
      />
    )
  }

  if (field.fieldType === FieldType.Address) {
    return <ReduxLocationPicker name={name} />
  }

  if (field.fieldType === FieldType.PickList || field.fieldType === FieldType.Switch) {
    const options = field.responseType
      ? responseTypeSets?.find((item) => item.id == field.responseTypeId)?.options || []
      : field.options

    return (
      <ReduxSelect
        name={name}
        options={getValueOptions({ ...field, fieldOptions: options })}
      />
    )
  }

  return <ReduxInput name={name} />
}

